import React from 'react';
import { TagFilled } from '@ant-design/icons';
import { Label } from '../../types/labels';

interface LabelDisplayProps {
	tag: Label;
	className?: string;
	style?: React.CSSProperties;
	showassociatedPartsCount?: boolean;
	darkMode?: boolean;
}

const LabelDisplay: React.FC<LabelDisplayProps> = ({
	tag,
	className = '',
	style = {},
	showassociatedPartsCount = false,
	darkMode = false,
}) => (
	<span
		className={`bodyregular inline-flex items-center justify-between gap-2 align-middle text-black/45 ${className}`}
		style={style}
	>
		<span className="inline-flex items-center gap-2">
			<TagFilled className="flex-shrink-0 text-xs" style={{ color: tag.color }} />
			<span className={darkMode ? 'text-grey-4' : ''}>{tag.label}</span>
		</span>
		{showassociatedPartsCount && typeof tag.associatedPartsCount === 'number' ? (
			<span className="text-black/45">({tag.associatedPartsCount})</span>
		) : null}
	</span>
);

export default LabelDisplay;
